import { combineReducers } from 'redux';
import { loggerUserReducer } from './loggerUserReducer';
import UserInformation from '../../types/UserInformation';
import { articleParamReducer } from './articleParamaReducer';
import ArticleInformation from '../../types/ArticleInformation';

export interface Reducers {
  logger: UserInformation | null;
  articleParm: ArticleInformation | null;
}

const allReducers = combineReducers<any>({
  logger: loggerUserReducer,
  articleParm: articleParamReducer
});

export default allReducers;
